module.exports = __webpack_public_path__ + "img/napravlen-4.ffc204d4.png";